import { render, staticRenderFns } from "./list.vue?vue&type=template&id=cc17a010&"
import script from "./list.vue?vue&type=script&lang=ts&"
export * from "./list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc17a010')) {
      api.createRecord('cc17a010', component.options)
    } else {
      api.reload('cc17a010', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=cc17a010&", function () {
      api.rerender('cc17a010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/list/list.vue"
export default component.exports